import { Box, Button, Container, CssBaseline, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { apiService } from "../../services/ApiService";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import { CheckCircleOutline } from "@mui/icons-material";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const AccountActivation = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { userId } = useParams();
  const [sessionToken, setSessionToken] = useState(null);
  const [opKey, setOpKey] = useState(null);

  useEffect(() => {
    const currentUrl = window.location.href;

    const url = new URL(currentUrl);

    const opkey = url.searchParams.get("opkey");
    const token = url.searchParams.get("token");

    setSessionToken(token);
    setOpKey(opkey);
    sessionStorage.setItem("opkey", opkey);
    return () => {};
  }, []);

  useEffect(() => {
    if (sessionToken) checkToken();
    return () => {};
  }, [sessionToken]);

  const checkToken = () => {
    try {
      console.log("Account activation token.", { sessionToken, userId, opKey });
      apiService
        .get(`authenticate/token/${sessionToken}/verify-activate`, {
          params: { userId, opKey },
        })
        .then((res) => res?.data || res)
        .then((response) => {
          console.log({ response });
          toast.dismiss();
          if (response.resultCode > 0) {
            toast.success(response.message);
          } else {
            toast.error(response.message || "Fail");
            console.log("ERROR::::");
          }
        })
        .catch((err) => {
          // sessionStorage.removeItem("opkey");
          // setTimeout(() => {
          //   window.location.href = "/";
          // }, 1500);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (executeRecaptcha) {
      console.log("reCAPTCHA is ready to use");
    }
    return () => {};
  }, [executeRecaptcha]);

  return (
    <>
      <CssBaseline />
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // full screen center
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 3,
              textAlign: "center",
              maxWidth: 400,
            }}
          >
            <CheckCircleOutline color="success" sx={{ fontSize: 60, mb: 2 }} />

            <Typography variant="h5" gutterBottom>
              Your account is successfully activated 🎉
            </Typography>
            <Typography variant="h6" gutterBottom>
              Welcome to Valydate4u!
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              You can now log in with your credentials and start the adventure.
            </Typography>

            <Button component="a" href="/" variant="contained">
              Login Now
            </Button>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default AccountActivation;
